import { useState } from 'react'
import { WeatherProvider } from './contexts/WeatherContext'
import { ChatProvider } from './contexts/ChatContext'
import ChatInterface from './components/ChatInterface'
import WeatherDashboard from './components/WeatherDashboard'
import WeatherComparison from './components/WeatherComparison'
import WeatherVisualization from './components/WeatherVisualization'
import { BarChart3, MessageSquare, Cloud } from 'lucide-react'

function App() {
  const [viewMode, setViewMode] = useState<'chat' | 'comparison' | 'visualization'>('chat')

  return (
    <WeatherProvider>
      <ChatProvider>
        {viewMode === 'visualization' ? (
          <WeatherVisualization />
        ) : (
          <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
            <div className="container mx-auto px-4 py-8">
              <header className="text-center mb-8">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">
                  ☀️ Weather Buddy AI
                </h1>
                <p className="text-gray-600 dark:text-gray-300 mb-4">
                  Your AI-powered weather assistant with physics-informed forecasting
                </p>
              </header>

              {/* View Mode Toggle - Outside the conditional */}
              <div className="flex justify-center gap-2 mb-8">
                <button
                  onClick={() => setViewMode('chat')}
                  className={`flex items-center gap-2 px-6 py-2 rounded-lg font-medium transition ${
                    viewMode === 'chat'
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <MessageSquare className="w-4 h-4" />
                  Chat & Dashboard
                </button>
                <button
                  onClick={() => setViewMode('comparison')}
                  className={`flex items-center gap-2 px-6 py-2 rounded-lg font-medium transition ${
                    viewMode === 'comparison'
                      ? 'bg-indigo-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <BarChart3 className="w-4 h-4" />
                  AI vs Real Weather
                </button>
                <button
                  onClick={() => setViewMode('visualization')}
                  className="flex items-center gap-2 px-6 py-2 rounded-lg font-medium transition bg-white text-gray-700 hover:bg-gray-100"
                >
                  <Cloud className="w-4 h-4" />
                  Immersive View
                </button>
              </div>

              {viewMode === 'chat' && (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div className="order-2 lg:order-1">
                    <WeatherDashboard />
                  </div>
                  <div className="order-1 lg:order-2">
                    <ChatInterface />
                  </div>
                </div>
              )}
              {viewMode === 'comparison' && (
                <div className="max-w-6xl mx-auto">
                  <WeatherComparison
                    latitude={40.7128}
                    longitude={-74.006}
                    locationName="New York City"
                    timezone="America/New_York"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </ChatProvider>
    </WeatherProvider>
  )
}

export default App
